// @flow
import styled from '@emotion/styled';
import { color } from '@tablekit/theme';
import Button from '@tablekit/button';
import CardStyles from 'styled/Card';
import Link from 'components/Link';

export const CardHoverLink = styled(Button)`
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  padding: 0;
  display: none;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const Card = styled(CardStyles.withComponent(Link), {
  shouldForwardProp: (prop) => ['cardAlign', 'totalCards'].indexOf(prop) === -1
})`
  color: ${color('text')};
  padding: 0;

  &,
  &:visited,
  &:active,
  &:hover {
    text-decoration: none !important;
  }

  &:hover ${CardHoverLink} {
    opacity: 1;
  }
`;
